export { Tabs } from './Tabs';
export { Tab } from './Tab/Tab';
export { TabPanel } from './TabPanel/TabPanel';
export { TabList } from './TabList/TabList';
